import { injectGlobal } from 'styled-components';
import { normalize } from 'polished';

import { fonts } from './fonts';
import { white, black } from 'styles/colors';
import { colors } from '@alixpartners/ui-components';

export default function() {
	return injectGlobal`
		${normalize()};
		${fonts};

		*,
		*:before,
		*:after {
			box-sizing: border-box;
		}

		html {
			font-family: 'Roboto', Helvetica, Arial, sans-serif;
			-webkit-font-smoothing: antialiased;
			background-color: ${white};
			color: ${black};
			overflow-y: hidden;
			overflow-x: auto;
			min-width: 1024px;
			/* TODO: Root typography to be reviewed */
			font-size: 16px;
			font-weight: normal;
			line-height: 1.3;
		}

		/* canvas block is used to meassure text sizes, just hide it */
		body > canvas{
			position: absolute;
			top: -10000px;
		}

		svg:not(:root) {
			overflow: visible;
		}

		a {
			color: inherit;
			text-decoration: none;
		}

		h1, h2, h3, h4, h5, h6 {
			margin: 0;
			font-weight: inherit;
		}

		p {
			margin: 0;
		}

		ul, ol {
			margin: 0;
			padding: 0;
			list-style: none;
		}

		table {
			border-collapse: collapse;
		}

		button {
			font: inherit;
			color: inherit;
			border-radius: 0;
			background-color: transparent;
		}

		input, textarea {
			font: inherit;
		}

		input[type="number"] {
			appearance: textfield;

			&::-webkit-outer-spin-button,
			&::-webkit-inner-spin-button {
				appearance: none;
				margin: 0;
			}
		}

		#adalIdTokenFrame {
			top: 0;
		}

		.tippy-popper .tippy-tooltip {
			border-radius: 1px;
			font-size: 11px;
			background-color: ${colors.grey6};
			max-width: 211px;
			padding: 4px 8px;
		}

		.tippy-popper[x-placement^=left] [x-arrow].arrow-regular {
			border-left-color: ${colors.grey6};
		}

		.tippy-popper[x-placement^=top] [x-arrow].arrow-regular {
			border-top-color: ${colors.grey6};
		}

		.tippy-popper[x-placement^=bottom] [x-arrow].arrow-regular {
			border-bottom-color: ${colors.grey6};
		}

		.tippy-popper[x-placement^=right] [x-arrow].arrow-regular {
			border-right-color: ${colors.grey6};
		}
	`;
}
